const Logo = require('assets/images/logo.svg')

export default [
  {
    id: 'logo',
    src: Logo
  }
]
